export default __webpack_public_path__ + "static/media/trim.b150a4fe.jpg";